import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { awsInstance } from "../../actions/api";
import { useRecoilValue, useRecoilState } from "recoil";
import { userState, companyFileNameState } from "../../stores/atoms";
import { S3, S3_BUCKET, S3_PATH, getTimeStamp, inputValidation } from "../../actions/utiles";
import Loading from "./../Loading";

function ModalForCompanyFile(props) {
  const user = useRecoilValue(userState);
  const [, setCompanyFileName] = useRecoilState(companyFileNameState);
  const [isFileInputValid, setIsFileInputValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [filePath, setFilePath] = useState(null);

  const fileInputRef = useRef();
  const companyFileRef = useRef();
  const fileButtonRef = useRef();

  const param = {
    'Bucket': S3_BUCKET,
    'Key': filePath,
    'Body': file,
    'ACL': 'public-read',
    'ContentType': 'application/pdf'
  }

  useEffect(() => {
    if (!props.show) {
      setFile("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  const onSaveClick = () => {
    if (!file) {
      setIsFileInputValid(false);
      return false;
    }
    try {
      if (isFileInputValid && file) {
        S3.upload(param, async (err, result) => {
          if (err) { 
            alert('파일 업로드에 실패했습니다. ' + err);
            return;
          } else {
            const params = new URLSearchParams({
              id: user.company_id,
              license_file_path: result.key,
              license_file_name: file.name
            });
            setLoading(true);
            const { data } = await awsInstance.put(
              `/business/company-license?${params}`
            );
            if (data.code === "SUCCESS") {
              alert("사업자 등록증이 정상적으로 등록되었습니다.");
              setCompanyFileName(file.name);
              props.onHide(true);
            } else {
              alert(data.message);
            }
          }
        });
      } else {
        setIsFileInputValid(false);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  };

  const handleFileButtonClick = (event) => {
    event.preventDefault();
    fileInputRef.current.click();
  }

  const onUploadFileChange = (event) => {
    const file = event.target.files[0];
    const fileName = file.name;
    const lastDot = fileName.lastIndexOf('.') + 1;
    const fileExt = fileName.substring(lastDot, fileName.length).toLowerCase();
    if(['pdf'].indexOf(fileExt) === -1) {
      alert('PDF파일만 가능합니다.');
      fileInputRef.current.value = null;
      return;
    }
    setFile(event.target.files[0]);
    setFilePath(S3_PATH + getTimeStamp() + '/license.pdf');
  }
  
  return (
    <>
      <Modal
        {...props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <span className="modal-title">사업자 등록증 업로드</span>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="d-flex flex-content-around">
              <input
                type="file"
                accept=".pdf"
                className="form-control mb-1"
                maxLength="20"
                onChange={onUploadFileChange}
                ref={fileInputRef}
                hidden
              />
              <input
                className={`form-control mb-1 mr-2 ${inputValidation(
                  setIsFileInputValid
                )}`}
                defaultValue={file ? file.name : ''}
                maxLength="20"
                ref={companyFileRef}
              />
              <button className="btn-dark-sm font-bold" ref={fileButtonRef} onClick={handleFileButtonClick}>
                첨부
              </button>
            </div>
            <span className="font-small txt-gray pb-3">
              파일을 첨부해주세요.(PDF파일만 가능합니다.)
            </span>
            <button className="btn-blue-md m-2" onClick={onSaveClick}>
              저장
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Loading loading={loading} />
    </>
  );
}

export default ModalForCompanyFile;
